var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import WarehouseService from '../../../api/WarehouseService';
import HeaderItem from "../../../components/HeaderItem";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        _this.outSupplierdepotOptions = [];
        _this.docTypeList = [
            { name: '订单采购', value: 1 },
            { name: '自定义采购', value: 0 }
        ];
        return _this;
    }
    default_1.prototype.watch_out_organ_id = function (newValue, oldValue) {
        var _this = this;
        if (this.handleStatus == 2)
            return;
        this.$emit('emptyGood');
        console.log(newValue);
        console.log(oldValue);
        if (newValue) {
            if (oldValue) {
                this.formData.out_depot_id = '';
            }
            this.getSupplierdepotOptions({
                organ_id: newValue
            }).then(function (list) {
                _this.outSupplierdepotOptions = list;
                var defaultDepot = list.filter(function (item) { return item.is_organ_default == 1; });
                defaultDepot = defaultDepot[0] ? defaultDepot[0].depot_id : '';
                _this.$nextTick(function () {
                    _this.formData.out_depot_id = defaultDepot;
                });
            });
        }
        else {
            this.outSupplierdepotOptions = [];
            this.formData.out_depot_id = '';
        }
    };
    default_1.prototype.watch_organ_id = function (newValue, oldValue) {
        var _this = this;
        if (this.handleStatus == 2)
            return;
        this.$emit('emptyGood');
        console.log(newValue);
        console.log(oldValue);
        if (newValue) {
            if (oldValue) {
                this.formData.depot_id = '';
            }
            this.getSupplierdepotOptions({
                organ_id: newValue
            }).then(function (list) {
                _this.supplierdepotOptions = list;
                var defaultDepot = list.filter(function (item) { return item.is_organ_default == 1; });
                defaultDepot = defaultDepot[0] ? defaultDepot[0].depot_id : '';
                _this.$nextTick(function () {
                    _this.formData.depot_id = defaultDepot != _this.formData.out_depot_id ? defaultDepot : '';
                });
            });
        }
        else {
            this.supplierdepotOptions = [];
            this.formData.depot_id = '';
        }
    };
    default_1.prototype.watch_out_depot_id = function (newValue, oldValue) {
        if (this.handleStatus == 2)
            return;
        this.$emit('emptyGood');
        console.log(newValue);
        console.log(oldValue);
        if (newValue) {
            if (newValue == this.formData.depot_id)
                this.formData.depot_id = '';
        }
    };
    default_1.prototype.created = function () {
        this.warehouseService = WarehouseService.getInstance();
        if (this.handleStatus == 1) {
            this.getSupplierorganOptions();
        }
    };
    default_1.prototype.mounted = function () { };
    default_1.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.warehouseService.getSupplierorganOptions().then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                if (res.data.data && res.data.data.length) {
                    var default_organ_id = res.data.data && res.data.data[0].organ_id || '';
                    if (!_this.formData.out_organ_id)
                        _this.formData.out_organ_id = default_organ_id;
                    if (!_this.formData.organ_id)
                        _this.formData.organ_id = default_organ_id;
                }
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var list = [];
            var params = {
                organ_id: data.organ_id,
                is_init: 1
            };
            _this.warehouseService.getSupplierdepotOptions(params).then(function (res) {
                if (res.data.success) {
                    list = res.data.data || [];
                }
                resolve(list);
            }).catch(function () {
                resolve(list);
            });
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch('formData.out_organ_id')
    ], default_1.prototype, "watch_out_organ_id", null);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watch_organ_id", null);
    __decorate([
        Watch('formData.out_depot_id')
    ], default_1.prototype, "watch_out_depot_id", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
